import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CareersHero from './components/CareersHero';
import WhyWorkSection from './components/WhyWorkSection';
import CultureSection from './components/CultureSection';
import OpenRolesSection from './components/OpenRolesSection';
import BenefitsSection from './components/BenefitsSection';
import CareersCTABand from './components/CareersCTABand';

export default function CareersPage() {
  return (
    <>
      <Navbar />
      <main>
        <CareersHero />
        <WhyWorkSection />
        <CultureSection />
        <OpenRolesSection />
        <BenefitsSection />
        <CareersCTABand />
      </main>
      <Footer />
    </>
  );
}